import React from 'react';
import PropTypes from 'prop-types';

class Categorie extends React.Component {
    render() {
        const { categorie, isLoading } = this.props;

        if (isLoading || !categorie) {
            return null;
        }

        // Il faut éventuellement ajouter un format.

        return categorie.libelle;
    }
}

Categorie.propTypes = {
    categorie: PropTypes.object,
    isLoading: PropTypes.bool.isRequired
};

export default Categorie;